import React from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const LeftCopy = ({ mobile }) => {
  const navigate = useNavigate();

  const preloadSimpelLoop = () => {
    const img1 = new Image();
    img1.src = "/images/simpel-loop-transparent.png";
    const img2 = new Image();
    img2.src = "/images/how-it-works-bg.png";
  };

  const handleExplore = () => {
    window.scrollTo(0, 0);
    navigate("/simpel-loop");
  };

  return (
    <div className={`flex flex-col gap-6 ${mobile ? "w-full" : "w-full"}`}>
      <p className="text-[11px] font-bold uppercase leading-[16.5px] tracking-[2.2px] text-white">
        OUR APPROACH
      </p>
      <h2 className="text-[30px] font-bold leading-[36px] text-white lg:text-[40px] lg:leading-[44px]">
        We don’t start with AI.
        <br />
        We start with your business.
      </h2>
      <p className="max-w-[512px] text-[16px] leading-[26px] text-[#CBD5E1]">
        Simpel LOOP™ connects your goals, business, <span className="underline">systems</span> and data to identify and deliver the right AI opportunities — and keep creating value over time.
      </p>
      <button
        onClick={handleExplore}
        onMouseEnter={preloadSimpelLoop}
        onPointerDown={preloadSimpelLoop}
        className="flex w-fit items-center gap-2 rounded-full bg-white px-6 py-3 text-[14px] font-semibold text-[#0B132B] shadow-md transition-all duration-200 hover:scale-[1.03] hover:shadow-lg cursor-pointer"
      >
        Explore Simpel LOOP™ <ArrowRight className="h-4 w-4" strokeWidth={2} />
      </button>
    </div>
  );
};

const ApproachSection = () => {
  return (
    <section 
      id="transform" 
      className="relative w-full overflow-hidden bg-[#070C1E]"
      style={{
        backgroundImage: "url('/images/approach_background.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      {/* Desktop Layout - Switched to a 12-column grid for better sizing control */}
      <div className="relative mx-auto hidden max-w-[1440px] items-center px-6 py-24 lg:flex lg:px-[70px]">
        <div className="grid w-full grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-8">
          
          {/* Left Text gets 5 columns (~40% width) */}
          <div className="lg:col-span-5">
            <LeftCopy />
          </div>

          {/* Right Image gets 7 columns (~60% width) */}
          <div className="flex w-full justify-end lg:col-span-7">
            <img 
              src="/images/8cloop.png" 
              alt="Simpel LOOP Methodology" 
              // Increased max-w and added scaling/translation to make it larger and closer to the edge
              className="w-full max-w-[900px] rounded-2xl object-contain shadow-2xl lg:translate-x-6 xl:scale-105" 
            />
          </div>
          
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="relative flex flex-col gap-10 px-6 py-16 lg:hidden">
        <LeftCopy mobile />
        <div className="w-full">
          <img 
            src="/images/8cloop.png" 
            alt="Simpel LOOP Methodology" 
            className="w-full rounded-xl object-contain shadow-lg" 
          />
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;